import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConnectivityService } from './connectivity.service';

@Injectable()
export class ConnectivityInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isHealthProbe = req.url.includes('/api/health');

    return next.handle(req).pipe(
      tap(() => {
        if (!isHealthProbe) {
          this.injector.get(ConnectivityService).notifyRequestSuccess();
        }
      }),
      catchError((err) => {
        if (!isHealthProbe && ConnectivityService.isNetworkError(err)) {
          this.injector.get(ConnectivityService).notifyRequestFailure(true);
        }
        return throwError(() => err);
      })
    );
  }
}
